export enum KipScale {
  fifteenMinutes = '15Min',
  oneHour = '1Hour',
  oneDay = '1Day',
  oneMonth = '1Month',
  rawData = 'RAW_DATA',
}

// TODO check consistency with backend
